<template>
  <img :src="thumbImage" />
</template>

<script lang="ts">
import { defineComponent, computed, unref } from "vue";
import { buildingThumb } from "~/lib/thumbs";

export default defineComponent({
  name: "BuildingThumb",
  props: {
    id: {
      type: Number,
      required: true,
    },
  },
  setup(props) {
    return {
      thumbImage: computed(() => unref(buildingThumb(props.id))),
    };
  },
});
</script>
